import {FC} from "react";
import TableConsolidatedBudget from "../../components/table/consolidatedbudget/TableConsolidatedBudget";
import styles from './consolidatedBudgetList.module.scss'

const ConsolidatedBudgetList: FC = () => {
    return (
        <div className={styles.consolidatedBudgetList}>
            <TableConsolidatedBudget/>
        </div>
    );
};

export default ConsolidatedBudgetList;
